export const KEY_THEME = 'theme';
export const KEY_COLLECTION = 'collection';
export const KEY_FAVORITE = 'favorite';
export const KEY_CURRENT_PAGE = 'current';
export const KEY_READ = 'read';
export const MAXLENGHT = 110;
export const CATEGOREIS = "categories";
